import './../../resources_membership_hotel/css/hotel/membership_reserve_cancel.css'

export const RoomInfoComf = (props) => {
    const { data } = props;
    return (
        <div>
            {data !== undefined && data.length !== 0 ?  data.map((value, index) => (
                <div className='membership_reserve_cancel_contentarea'>
                    <div className='membership_reserve_cancel_title no_margin'/>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid str_padding'>
                            {
                                value.machiList ? value.machiList.map((machiDate) => {
                                    return(
                                        <div className='membership_reserve_cancel_info_machi_date'>※{machiDate.machiDate}待ち</div>
                                    )
                                })
                                :
                                null
                            }
                            <div className='membership_reserve_cancel_subtitle block sp_label'>{index + 1}室目</div>
                            <div className='membership_reserve_cancel_room'>
                                <div className='membership_reserve_cancel_info block'>{value.hyjRmType}</div>
                            </div>
                        </div>
                        {value.roomNums.map((value, index) => (
                            index === 0 ?
                            <div className='membership_reserve_cancel_wid str_padding no_padding'>
                                <div className='membership_reserve_cancel_subtitle2 sp_label'>ご利用人数</div>
                                <div className='membership_reserve_cancel_info2'>{value.parson}</div>
                                <div className='membership_reserve_cancel_info3'>{value.num}</div>
                            </div>
                            :
                            <div className='membership_reserve_cancel_wid str_padding no_padding'>
                                <div className='membership_reserve_cancel_subtitle2'/>
                                <div className='membership_reserve_cancel_info2'>{value.parson}</div>
                                <div className='membership_reserve_cancel_info3'>{value.num}</div>
                            </div>
                         ))
                        }
                    </div>
                </div>
            ))
            : null}
        </div>
    );
};